
import { initializeApp } from 'firebase/app'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import React, { PureComponent, useContext, useEffect, useState } from 'react'
import { LoaderIcon } from 'react-hot-toast'
import { Outlet, useNavigate } from 'react-router-dom'
import { AuthContext } from '../../context/auth'
import { firebaseConfig } from '../../firebaseConfig'
import { removeLocalStorage, setToLocalStorage } from '../helper/auth'
import Loading from './Loading'

export default function PrivateRoute () {
   const [authc, setAuth] = useContext(AuthContext);
   const [loading,setLoading]=useState(true)
   const navigate = useNavigate()
   useEffect(() => {

   const app = initializeApp(firebaseConfig);
   const auth = getAuth()
   onAuthStateChanged(auth, (user) => {
      if (user) {
         setAuth(user)
         setToLocalStorage("auth",user)
        setLoading(false)
      } else {
         setLoading(true)
         setAuth(null)
         removeLocalStorage("auth")
      }
    });

   
    
   }, [])
   
   return loading ? <Loading/>: <Outlet/>
}

